import React from 'react';
import { BookOpen, Layers, Target, Calendar } from 'lucide-react';
export function Stats() {
  const stats = [{
    icon: BookOpen,
    value: '+22',
    label: 'Capítulos'
  }, {
    icon: Layers,
    value: '6',
    label: 'Partes'
  }, {
    icon: Target,
    value: '+30',
    label: 'Jugadas'
  }, {
    icon: Calendar,
    value: '90',
    label: 'Días de Plan'
  }];
  return <section className="w-full bg-[#0a0a0a] py-12 px-4" data-id="element-134">
      <div className="max-w-6xl mx-auto" data-id="element-135">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-136">
          {stats.map((stat, index) => <div key={index} className="text-center" data-id="element-137">
              <stat.icon className="w-10 h-10 text-[#C6FF3C] mx-auto mb-3" data-id="element-138" />
              <div className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-139">
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm uppercase" data-id="element-140">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}